import type { GetAllDesktopSettingsData } from 'shared/api/containerApi'
import type { SaveWidgetRequest } from 'shared/api/containerApi/requests'
import { WidgetSize } from 'shared/constants/widgets'
import type { PersistedWidgetSpec } from 'shared/types/widgets'

import { transformWidgetsForSave } from './transformWidgetsForSave'

const validSizes = new Set<string>(Object.values(WidgetSize))

/** Stored rows must be valid for the backend's bulk upsert validation. */
export const canPersistWidgetOrder = (
  data: GetAllDesktopSettingsData | undefined
): boolean =>
  Boolean(data?.widgets.every(widget => validSizes.has(widget.size)))

/** The backend treats a payload missing any stored ID as a partial upsert. */
export const buildWidgetOrderSavePayload = (
  data: GetAllDesktopSettingsData,
  nextWidgets: PersistedWidgetSpec[]
): SaveWidgetRequest[] => {
  const nextIds = new Set(nextWidgets.map(widget => widget.id))
  const hiddenRows = data.widgets.filter(widget => !nextIds.has(widget.id))

  return [
    ...transformWidgetsForSave(nextWidgets, data.widgets),
    ...hiddenRows.map((widget, index) => ({
      id: widget.id,
      widget_key: widget.widget_key,
      configuration: widget.configuration,
      size: widget.size,
      display_order: nextWidgets.length + index + 1,
      is_collapsed: widget.is_collapsed
    }))
  ]
}
